// extracted by mini-css-extract-plugin
export var alignCenter = "_98-d";
export var bannerShown = "_98-6";
export var buttonContent = "_98-0";
export var cardList = "_98-1";
export var centerContent = "_98-2";
export var chevron = "_98-3";
export var closePanelButton = "_98-k";
export var conversationContextContainer = "_98-l";
export var conversationDetailContainer = "_98-4";
export var detailWrapper = "_98-7";
export var dropdownButton = "_98-e";
export var dropdownTitle = "_98-9";
export var fullHeight = "_98-5";
export var hidden = "_98-a";
export var icon = "_98-b";
export var mergeSuggestionWrapper = "_98-m";
export var panel = "_98-i";
export var portalButtonsWrapper = "_98-c";
export var right = "_98-j";
export var tableSummaryContainer = "_98-8";
export var tableSummaryHeader = "_98-g";
export var threeDotsButton = "_98-f";
export var wide = "_98-h";